export default __webpack_public_path__ + "static/media/keyboard.dc7aa798.svg";